import { useMemo, useState } from "react";

interface UseReactionFooterStateOptions {
  isAnyActionLoading: boolean;
  disabled: boolean;
  reactionTotal: number;
  hasReactionTarget: boolean;
}

export const useReactionFooterState = ({
  isAnyActionLoading,
  disabled,
  reactionTotal,
  hasReactionTarget,
}: UseReactionFooterStateOptions) => {
  const [reactionRefreshKey, setReactionRefreshKey] = useState(0);

  const isActionDisabled = isAnyActionLoading || disabled;
  const reactionSummaryShouldRender = useMemo(
    () => (reactionTotal > 0 || reactionRefreshKey > 0) && hasReactionTarget,
    [reactionTotal, reactionRefreshKey, hasReactionTarget],
  );

  return {
    reactionRefreshKey,
    isActionDisabled,
    reactionSummaryShouldRender,
    bumpReactionRefreshKey: () => setReactionRefreshKey((prev) => prev + 1),
  };
};
